export const ruleRequired = (msg = 'Required!') => value => !!value || msg;

export const ruleMinLength = (length, msg) => value => `${value}`.length >= length || msg;

export const ruleMin = (length, msg) => value => value >= length || msg;

export const ruleMax = (length, msg) => value => value <= length || msg;

// eslint-disable-next-line no-shadow
export const ruleRegex = (regex, msg) => value => !value || regex.test(`${value}`) || msg;

// eslint-disable-next-line no-useless-escape
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ruleEmail = (msg = 'Invalid Email Address!') => value => !value || emailRegex.test(`${value}`.toLowerCase()) || msg;

// rule for post code
export const rulePostCode = (msg = 'Invalid Post Code!') => value => !value || /^[0-9]{4}$/.test(`${value}`) || msg;

export const ruleConfirmed = (confirmedValue, msg) => value => value === confirmedValue() || msg;

export const ruleInArray = (values, msg) => value => values.includes(value) || msg;

export const ruleMinSelected = (length, msg) => value => value.length > 0 || msg;

export const ruleIsValidExpiryDays = msg => value => !value || (value >= 30 && value <= 365) || msg;
